<template>
  <div class="bootPage" ref="bootPage">
    <div class="box">
      <h6>智工嗨搜</h6>
      <p>一键检索海外买家资源信息，助您高效获取销售线索</p>
      <div class="bootPage-video">
        <!-- TODO 这里要换成腾讯云点播的方式 -->
        <video
          controls="controls"
          loop="loop"
          src="https://1500000359.vod2.myqcloud.com/43816be1vodtranscq1500000359/92d48d8e3270835010738021340/v.f20.mp4"
          poster="../../assets/image/boot-page/video.png"
        ></video>
      </div>
    </div>
    <div class="bootPage-advantage">
      <div class="w">
        <div class="title">
          <img src="@/assets/image/boot-page/text.png" alt="" />
        </div>
        <div class="bottom">
          <div class="imgs">
            <div class="li">
              <img src="@/assets/image/boot-page/advantage1.png" alt="" />
              <div>专业买家资源</div>
            </div>
            <div class="li">
              <img src="@/assets/image/boot-page/advantage2.png" alt="" />
              <div>直连领英主页</div>
            </div>
            <div class="li">
              <img src="@/assets/image/boot-page/advantage3.png" alt="" />
              <div>快速批量触达</div>
            </div>
            <div class="li">
              <img src="@/assets/image/boot-page/advantage4.png" alt="" />
              <div>智能AI助手</div>
            </div>
          </div>
          <div
            class="btn"
            v-if="accessData && (accessData.accessPermission === 2 || accessData.accessPermission === 4)"
            @click="preempt"
          >海智{{ accessData.memberTypeStr }}抢先体验<i class="iconfont icon-icon-jiantou"></i></div>
          <div
            class="btn"
            v-if="accessData && accessData.accessPermission === 3"
            @click="applicationExperience"
          >
            申请体验
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      custom-class="applicationExperienceDialog"
      :visible.sync="dialogVisible"
      width="587px"
    >
      <div class="content">
        <div class="icon">
          <i class="iconfont icon-icon-feiloukong"></i>
        </div>
        <p>感谢您提交申请！管理员已收到您的申请信息，我们将尽快为您安排</p>
        <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import {
  applySearchPermission,
} from '@/utils/api/permission-verification.js'
import ServiceAgreement from '@/components/common/ServiceAgreement'
export default {
  components: {
    ServiceAgreement,
  },
  computed: {
    ...mapState('permissionVerification', ['accessData']),
  },
  data() {
    return {
      serviceAgreementShow: true,
      dialogVisible: false,
    }
  },
  methods: {
    ...mapMutations('permissionVerification', ['SET_ACCESS_DATA']),

    // 抢先体验
    async preempt() {
      try {
        // 记录行为, 不做等待，即使异常也不影响后续实名认证
        applySearchPermission({})
      } catch (err) {
        console.error("❌ ~ file: home.vue:102 ~ preempt ~ err:", err)
      }
      // 如果 accessPermission 为 4， 代表是已认证未激活，直接去激活页
      this.$router.push({
        path:
          this.accessData.accessPermission === 4
            ? 'launch-product'
            : 'real-name',
        query: {
          to: this.$route.query.to,
          certification: this.accessData.accessPermission === 4 ? 1 : undefined,
        },
      })
    },

    // 申请体验
    async applicationExperience() {
      try {
        // 记录行为
        const res = await applySearchPermission({})
        if (res.rspResult.bizCode === 200) {
          this.dialogVisible = true
        }
      } catch (err) {
        console.error("❌ ~ file: home.vue:126 ~ applicationExperience ~ err:", err)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.bootPage {
  box-sizing: border-box;
  background-color: rgb(217, 224, 240);
  min-height: calc(100vh - 96px);
  padding-top: 32px;
  text-align: center;
  background-image: url('~@/assets/image/boot-page/background.png');
  background-size: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .box {
    > h6 {
      font-family: SourceHanSansCN-Bold;
      font-weight: 700;
      font-size: 20px;
      color: #16181a;
      letter-spacing: 0;
      height: 20px;
      line-height: 20px;
    }
    > p {
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 16px;
      color: #16181a;
      letter-spacing: 0;
      margin-top: 16px;
      margin-bottom: 28px;
    }
    .bootPage-video {
      width: 736px;
      height: 414px;
      background: #000000;
      border-radius: 4px;
      margin: 0 auto;
      overflow: hidden;
      video {
        width: 100%;
        height: 100%;
      }
      @media screen and (min-width: 1910px) {
        width: 912px;
        height: 513px;
      }
    }
  }

  &-advantage {
    margin-top: 37px;
    box-shadow: 0 -2px 10px 0 #001aa31a;
    /* 为边框添加渐变 */
    border-style: solid;
    border-width: 2px;
    border-image: linear-gradient(#fff, transparent) 30 30;
    border-bottom: none;
    backdrop-filter: blur(10px);
    padding: 0 2px;
    .w {
      width: 900px;
      margin: 0 auto;
      height: 151px;
      padding-top: 20px;
      @media screen and (min-width: 1910px) {
        width: 1000px;
      }
      box-sizing: border-box;
      .title {
        text-align: left;
        img {
          width: 161px;
          margin-left: 8px;
        }
      }
      > .bottom {
        margin-top: 11px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .imgs {
          display: flex;
          .li {
            width: 92px;
            text-align: left;
            margin-right: 52px;
            @media screen and (min-width: 1910px) {
              margin-right: 70px;
            }
            &:last-child {
              margin-right: 0;
            }
            img {
              width: 60px;
            }
            > div {
              margin-left: 8px;
              font-family: SourceHanSansCN-Regular;
              font-weight: 400;
              font-size: 14px;
              color: #16181a;
              margin-top: 8px;
              line-height: 14px;
              height: 14px;
            }
          }
        }
        .btn {
          cursor: pointer;
          width: auto;
          padding: 0 20px;
          height: 44px;
          line-height: 44px;
          background-image: linear-gradient(0deg, #0095ff 0%, #5985fc 100%);
          box-shadow: 0 2px 10px 0 #0039684d, inset 0 2px 4px 0 #ffffff66;
          border-radius: 4px;
          font-family: SourceHanSansCN-Bold;
          font-weight: 700;
          font-size: 16px;
          color: #ffffff;
          border: 1px solid #fff;
          font-weight: normal;
          i {
            margin-left: 16px;
          }
        }
      }
    }
  }
  ::v-deep .applicationExperienceDialog {
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding-top: 48px;
    }
    .el-dialog__headerbtn {
      top: 32px;
      right: 32px;
      font-size: 20px;
      i {
        font-weight: bold;

      }
    }
    .content {
      .icon {
        margin: 0 auto 20px;
        width: 30px;
        height: 30px;
        background-color: #0bb976;
        display: flex;
        justify-content: center;
        align-items: center;
        i {
          font-size: 46px;
          color: #e6f8f1;
        }
      }
      p {
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #4f5d78;
        margin-bottom: 36px;
      }
      .el-button {
        width: 120px;
        height: 40px;
        background: #066eb7;
        border-radius: 4px;
        font-size: 14px;
      }
    }
  }
  @media screen and (max-width: 1550px) {
    padding-top: 24px;
    .box {
      > p {
        margin-top: 12px;
        margin-bottom: 20px;
      }
      .bootPage-video {
        width: 576px;
        height: 324px;
      }
    }
    &-advantage {
      margin-top: 16px;
      .w {
        height: 143px;
        > .bottom {
          align-items: start;
          .imgs {
            display: flex;
            .li {
              > div {
                margin-top: 5px;
              }
            }
          }

        }
      }
    }
  }
}
</style>
